import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { CheckboxWithLabel } from '@grandvisionhq/forms';

const LaunchEyeExam = ({ className , consentValue , hideConsent , errorMissingConsent , onChangeConsent , onSubmit , isLoading , labels ,  })=>{
    return /*#__PURE__*/ React.createElement("form", {
        noValidate: true,
        className: classnames('launch-eye-exam', className),
        onSubmit: onSubmit
    }, !hideConsent && /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
        className: "launch-eye-exam__checkbox",
        label: labels.consentText,
        id: "lauch_eye_exam",
        value: consentValue,
        error: errorMissingConsent,
        errorMessage: labels.missingConsentError,
        checked: consentValue,
        onChange: onChangeConsent,
        disabled: isLoading
    }), /*#__PURE__*/ React.createElement(Button, {
        type: "submit",
        className: "launch-eye-exam__btn",
        caption: labels.caption,
        isLoading: isLoading
    }));
};

export { LaunchEyeExam };
//# sourceMappingURL=LaunchEyeExam.js.map
